<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="paper_edit_title flex">
					<div class="paper_edit_title_l">
						<p class="f20px">{{name}}</p>
						<div class="f16px cl_gray mat10">
							<span class="mar15">年级：<i class="cl_dark">{{grade_name}}</i></span>
							<span class="mal15">学科：<i class="cl_dark">{{subject_name}}</i></span>
						</div>
					</div>
					<router-link :to="{ path: '/paper_found', query: { id: id }}" class="paper_edit_title_r tc cl_white">编辑试卷</router-link>
				</div>
				<div class="paper_edit mat30">
					<div class="paper_edit_l">
						<div class="paper_edit_nav f18px cl_dark">
							<div class="paper_edit_nav_list" :class="{'on': nav_cur == 1}" @click="navCheck(1)">试卷</div>
							<div class="paper_edit_nav_list" :class="{'on': nav_cur == 2}" @click="navCheck(2)">答案与解析</div>
						</div>
						<div class="paper_edit_cont mat20 bs" :style="{maxHeight:height}">
							 <pdf v-for="i in numPages" :key="i" :src="src" :page="i" @page-loaded="pageLoaded($event)"></pdf>
						</div>
					</div>
					<div class="paper_edit_r" ref="paper_height">
						<div class="tc f20px">答题卡</div>
						<div class="paper_edit_card mat20">
							<div class="paper_card_list" v-for="(item,index) in list" :key="index">
								<div class="found_list_title flex f16px cl_violet radius8">
									<div class="found_list_title_l">{{item.number}}、{{item.type}}</div>
									<div>共{{item.topic.length}}题，{{item.fraction_all}}分</div>
								</div>
								<div class="found_list_cont mat20">
									<div class="found_list_item flex radius8" v-for="(second,secondIndex) in item.topic" :key="secondIndex">
										<div class="found_list_item_l flex">
											<div class="found_list_item_index">{{second.id}}</div>
											<div class="found_list_item_cont flex" v-if="item.type == '选择题'">
												<div class="found_list_item_check_cont flex cl_gray tc">
													<div class="radius found_list_item_check" v-for="(third,thirdIndex) in second.arr" :key="thirdIndex"
													:class="{'on': third.check}">{{third.name}}</div>
												</div>
											</div>
											<div class="found_list_item_cont flex" v-if="item.type == '判断题'">
												<div class="found_list_item_judge cl_gray tc" v-for="(third,thirdIndex) in second.arr" :key="thirdIndex"
												:class="{'on': third.check}">{{third.name}}</div>
											</div>
											<div class="found_list_item_cont" v-if="['选择题','判断题'].indexOf(item.type) < 0">
												<p class="f12px cl_gray">本小题作为主观题，不提供在线作答功能，由学生<br>在线下用纸笔作答，并自行校对答案并计算得分。</p>
											</div>
										</div>
										<div class="found_list_item_r"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	import pdf from 'vue-pdf'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
			pdf,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 6,
					listCur: 2,
					open: 0,
				},
				id: "",
				list: [],
				name: "",
				subject_name: "",
				grade_name: "",
				ques_file: "",
				answ_file: "",
				nav_cur: 1,
				loading: true,
				src: '',
				numPages: undefined, // 总页数
				curPageNum: 0, //当前页
				height: "600px",
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
				this.getPaper();
			}
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//试卷
			getPaper () {
				this.$get("/api/teacher/get_examination_paper_show",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					this.list = res.data.card_json_arr;
					this.name = res.data.name;
					this.subject_name = res.data.subject_name;
					this.grade_name = res.data.grade_names;
					this.ques_file = res.data.ques_file;
					this.answ_file = res.data.answ_file;
					let that = this;
					that.src = pdf.createLoadingTask(this.ques_file); // url是pdf文件的全路径
					that.src.promise.then(pdf => {
							that.numPages = pdf.numPages;
					});
					setTimeout(() => {
						let height= this.$refs.paper_height.offsetHeight;
						if (height > 600) {
							this.height = height - 60 + "px"
						}
					}, 0);
				});
			},
			navCheck (e) {
				this.nav_cur = e;
				this.curPageNum = 0;
			},
			pageLoaded(e) {
				this.curPageNum = e;
				if (this.curPageNum == this.numPages) { //加载完最后一页
					this.loading = false;
				}
			},
		},
	}
</script>

<style>
</style>
